import { StateCreator } from "zustand";
import { GlobalState } from "../globalStore";
import type { SituationCategory, Situation } from "@/core/fastapiClient/sdk";

export interface SituationState {
  data: Situation[]; // this is how it comes from backend, most usable form for all consumers
  isLoading: boolean;
  error: string | null;
  reoderedByUser?: Record<SituationCategory, string[]>; // track which users situation order by each category (do it by category as UI nagivates the user)
}

export interface SituationSlice {
  situations: SituationState;
  setSituations: (situations: Situation[]) => void;
  setSituationsLoading: () => void;
  setSituationsError: (error: string) => void;
  resetSituations: () => void;
  // sorting
  setSituationOrder: (
    categoryKey: SituationCategory,
    orderedIds: string[]
  ) => void;
  // Initial state loading
  initFetchedSituations: boolean;
  setInitFetchedSituations: (fetched: boolean) => void;
}

export const createSituationSlice: StateCreator<
  GlobalState,
  [],
  [],
  SituationSlice
> = (set) => ({
  situations: {
    data: [],
    isLoading: false,
    error: null,
  },
  setSituations: (data) =>
    set({
      situations: { data, isLoading: false, error: null },
    }),
  setSituationsLoading: () =>
    set((state) => ({
      situations: { ...state.situations, isLoading: true, error: null },
    })),
  setSituationsError: (error) =>
    set((state) => ({
      situations: { ...state.situations, error, isLoading: false },
    })),
  resetSituations: () =>
    set({
      situations: { data: [], isLoading: false, error: null },
    }),
  // sorting
  setSituationOrder: (categoryKey, orderedIds) =>
    set((state) => ({
      situations: {
        ...state.situations,
        reoderedByUser: {
          occupation: state.situations.reoderedByUser?.occupation || [],
          education: state.situations.reoderedByUser?.education || [],
          development: state.situations.reoderedByUser?.development || [],
          preference: state.situations.reoderedByUser?.preference || [],
          [categoryKey]: orderedIds,
        },
      },
    })),
  // Initial state loading
  initFetchedSituations: false,
  setInitFetchedSituations: (fetched) =>
    set({ initFetchedSituations: fetched }),
});
